// src/hooks/useWindowSize.js
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setMobileView } from "../../../../reducers/InitialConfig/action";
import React from "react";

const useWindowSize = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= 800;
      dispatch(setMobileView(isMobile));
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch]);
};

// export default useWindowSize;

const WindowLayout = () => {
  useWindowSize();
  return <></>;
};

export default WindowLayout;
